import React, { useState } from 'react';
import ApplicationForm from '../components/ApplicationForm';
import AboutUs from '../components/AboutUs';
import SpecializedPrograms from '../components/SpecializedPrograms';
import CelebratingAchievements from '../components/CelebratingAchievements';
import StudentServices from '../components/StudentServices';
import UniversityEvents from '../components/UniversityEvents';
import FAQ from '../components/FAQ';

const AboutUsPage = () => {
  const [showApplicationModal, setShowApplicationModal] = useState(false);

  return (
    <>
      {/* About Section */}
      <AboutUs />

      {/* Specialized Programs Section */}
      <SpecializedPrograms setShowApplicationModal={setShowApplicationModal} />

      {/* Celebrating Our Achievements Section */}
      <CelebratingAchievements />

      {/* Student Services Section */}
      <StudentServices />

      {/* University Events Section */}
      <UniversityEvents />

      {/* FAQ Section */}
      <FAQ />

      {/* Application Modal */}
      <ApplicationForm 
        show={showApplicationModal} 
        onHide={() => setShowApplicationModal(false)} 
      />
    </>
  );
};

export default AboutUsPage;
